import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();

export const setPreferences = (data) => {
  return API.post(`settings/preferences/preferences`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const setAllowedDomains = (data) => {
  return API.post(`settings/preferences/allowed_domains`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const setEntityRules = (data) => {
  return API.post(`settings/preferences/entity_rules`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const setPACheckRules = (data) => {
  return API.post(`settings/preferences/pa_check_rules`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getPolicyTypes = (data) => {
  return API.get(`settings/customise/list/policy-types`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const addUpdatePortalConfig = (data) => {
  return API.post(`settings/preferences/preferences`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getConfigData = (payload) => {
  return API.get(`settings/config`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const saveAllowedDomains = (data) => {
  return API.post(`settings/preferences/allowed_domains`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getVendors = () => {
  return API.get(`/settings/customise/list/sourcing`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getPaCustomFieldList = (payload) => {
  return API.get(`/settings/pa-custom-fields/list?orgs_id=${encodeURIComponent(payload.orgId)}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const savePaCustomField = (data) => {
  return API.post(`settings/pa-custom-fields/new`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const updatePaCustomField = (data) => {
  return API.put(`settings/pa-custom-fields/single/${encodeURIComponent(data.PK)}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const deletePaCustomField = (data) => {
  return API.delete(`settings/pa-custom-fields/single/${encodeURIComponent(data.PK)}`, {}, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};
